























import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import BudgetExpense from "@/models/porposal/budgetExpense.model";
@Component
export default class BudgetItemBase extends BaseVue {
  protected id: number | null = null;
  protected loading = false;
  protected repository!: BaseRepository<BudgetExpense>;
  protected name: any = "";
  protected model: BudgetExpense | any = null;

  created() {
    this.id = Number.parseInt(this.$route.params.budgetExpenseId);
    if (this.hasParent && this.model == null) {
      this.repository = new BaseRepository<BudgetExpense>("BudgetExpense");
      this.getData();
    }
  }

  @Watch("model")
  onModelChange() {
    if (this.model)
      this.name = this.hasParent && this.model ? this.model.name : "---";
  }
  gotToList() {
    this.$router.push("/budget-expense");
  }
  protected async getData() {
    try {
      if (this.id) {
        this.model = await this.repository.getById(this.id);
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
    }
  }
  get hasParent() {
    return !!this.$route.params.budgetExpenseId;
  }
}
